import { gql } from 'graphql-request'

export const CREATE_NEWS = gql`
  mutation CreateNews($createNewsInput: CreateNewsInput!) {
    createNews(createNewsInput: $createNewsInput) {
      id
    }
  }
`
